<template>
  <div class="ticactoe" style="width: 100%;">

    <div v-if="!connected" style="text-align: center;margin-top: 20px;">
      <el-text class="mx-1" style="color: white;font-size: 30px;">本地程序已掉线，请检查或重启...~</el-text>
      <br/>
    </div>
    <div v-if="connected && !isAuth" style="text-align: center;margin-top: 20px;">
      <el-form class="center-button">
        <el-form-item>
          <el-text class="mx-1" style="color: white;font-size: 20px;">请输入密钥</el-text>
          <br/>
        </el-form-item>
        <el-form-item>
          <el-input class="dynamic-width-input" v-model="secret" placeholder="请输入密钥"
                    clearable/>
        </el-form-item>
        <el-form-item>
          <el-text class="mx-1" style="color: white;font-size: 20px;">如有疑问，请联系技术支持</el-text>
        </el-form-item>
        <el-form-item>
          <button class="custom-btn btn-9 center-button" @click="handleActive"><span>激 活</span></button>
        </el-form-item>
      </el-form>
    </div>
    <div class="button-container" v-if="connected && isAuth">
      <button class="custom-btn btn-9" @click="handleAdd"><span>添加任务</span></button>
<!--      <button class="custom-btn btn-9" @click="handleEdit(scope.$index, scope.row)"><span>编辑任务</span></button>-->
    </div>

    <div class="user_skills" v-if="connected && isAuth"  style="margin-top:20px;">
      <!--      按钮-->
      <el-table :data="filterTableData" style="width: 100%;color: white;"
                :header-cell-style="{background:'#eef1f6',color:'#606266'}">
        <el-table-column label="序号" prop="order" width="80"/>
        <el-table-column label="任务名称" prop="taskName" width="150" />
        <el-table-column label="目标群" prop="aimRoomName" width="150" />
        <el-table-column label="目标群ID" prop="aimRoomId" width="150" />
        <el-table-column label="任务类型" prop="taskType" width="100"/>
        <el-table-column label="总开关" align="center" width="100">
          <template #default="scope">
            <div class="icon-container">
              <el-icon :size="20" v-if="scope.row.isOpen">
                🍖
              </el-icon>
              <el-switch style="margin: 0 10px;" v-model="scope.row.isOpen" active-color="#9900ff"
                         @change="handleSwitchChange(scope.row, $event)"/>
              <!--							<el-button color="#626aef" size="large" @click="handleEdit(scope.$index, scope.row)">设置</el-button>-->
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template #header>
            <el-input v-model="search" clearable @input="searchChange" size="" placeholder="搜索任务"/>
          </template>
          <template #default="scope">
            <div class="icon-container" style="display: flex;gap: 10px;">
              <button class="custom-btn btn-9 left-btn" style="flex: 5" @click="handleEdit(scope.$index, scope.row)"><span>编辑任务</span></button>
              <button class="custom-btn btn-9 right-btn" style="flex: 1" @click="showHandleDelete(scope.$index, scope.row)"><span>X</span></button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加分页器 -->
      <el-pagination v-if="allRoomSettings.length > pageSize" :background="true" layout="prev, pager, next"
                     :page-count="pageCount" @current-change="changePage"/>
    </div>



    <el-dialog class="dialog-content" v-model="dialogFormVisible" title="选项配置"
               style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
      <el-form ref="form" :model="itemSettings" label-width="80px">
        <el-form-item :label="'🚀 ' + '任务类型'" :label-width="formLabelWidth">
          <el-select
              v-model="itemSettings.taskType"
              class="m-2"
              placeholder="任务类型"
              style="width: 100px"
              @change="handleTaskTypeChange"
          >
            <el-option
                v-for="item in taskList"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="任务名称" :label-width="formLabelWidth">
          <el-input class="dynamic-width-input" v-model="itemSettings.taskName"
                    placeholder="请输入任务名称" clearable/>
        </el-form-item>

        <el-form-item label="目标微信或群聊" :label-width="formLabelWidth">
          <el-select
              v-model="itemSettings.aimRoomId"
              class="m-2"
              filterable
              placeholder="输入关键字检索"
              style="width: 200px"
              @change="handleRoomChange"
          >
            <el-option
                v-for="item in room_list"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="handleShowNextPage(itemSettings)">
              下一步
            </el-button>
          </span>
      </template>
    </el-dialog>

    <el-dialog class="dialog-content" v-model="dialogForwordVisible" title="转发消息模块" @close="dialogForwordVisible = false"
               style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
      <span style="font-size: 16px; font-weight: 500;">说明: 转发发送预设的内容信息</span>
      <el-text style="margin-bottom: 10px;"></el-text>
      <el-form ref="form" :model="forwordSettings" label-width="80px">
        <el-form-item label="监控消息类型" :label-width="formLabelWidth">
          <el-select
              v-model="forwordSettings.message_types"
              class="m-2"
              filterable
              placeholder="输入消息类型"
              style="width: 200px"
              multiple
          >
            <el-option
                v-for="item in message_type_list"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="触发关键字" :label-width="formLabelWidth">
          <el-select
              v-model="forwordSettings.key_contents"
              class="m-2"
              filterable
              allow-create
              placeholder="输入触发关键字"
              style="width: 200px"
              multiple
          >
            <el-option
                v-for="item in key_contents_list"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="转发到人或群" :label-width="formLabelWidth">
          <el-select
              v-model="forwordSettings.forword_to"
              class="m-2"
              filterable
              placeholder="输入转发到人或群"
              style="width: 200px"
              multiple
          >
            <el-option
                v-for="item in room_list"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="BackLastStep()">
              上一步
            </el-button>
            <el-button @click="dialogForwordVisible = false">取消</el-button>
            <el-button type="primary" @click="SaveFormData(forwordSettings)">
              保存
            </el-button>
          </span>
      </template>
    </el-dialog>

    <el-dialog class="dialog-content" v-model="dialogIntervalVisible" title="定时发送模块" @close="dialogIntervalVisible = false"
               style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
      <span style="font-size: 16px; font-weight: 500;">说明: 定时发送预设的内容信息,无限次可设置9999</span>
      <el-text style="margin-bottom: 10px;"></el-text>
      <el-form ref="form" :model="intervalSettings" label-width="80px">
        <el-form-item :label="'🚀 ' + '循环次数'" :label-width="formLabelWidth">
          <el-input class="dynamic-width-input" type="number" v-model="intervalSettings.timer"
                    placeholder="请输入循环次数" clearable/>
        </el-form-item>

        <el-form-item label="发送间隔(s)" :label-width="formLabelWidth">
          <el-input class="dynamic-width-input" type="number" v-model="intervalSettings.intervalTime"
                    placeholder="请输入发送间隔" clearable/>
        </el-form-item>

        <el-form-item label="发送内容" :label-width="formLabelWidth">
          <el-input class="dynamic-width-input" type="textarea" :rows="3" v-model="intervalSettings.content"
                    placeholder="请输入文本" clearable/>
        </el-form-item>
        <el-form-item :label="'📍 ' + '艾特人(可多选)'" :label-width="formLabelWidth">
          <el-select
              v-model="intervalSettings.atList"
              class="m-2"
              placeholder="选择需要@的人"
              style="width: 300px"
              filterable
              multiple
          >
            <el-option
                v-for="item in room_members"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="BackLastStep()">
              上一步
            </el-button>
            <el-button @click="dialogIntervalVisible = false">取消</el-button>
            <el-button type="primary" @click="SaveFormData(intervalSettings)">
              保存
            </el-button>
          </span>
      </template>
    </el-dialog>

    <el-dialog class="dialog-content" v-model="dialogDeleteConfirm" title="操作确认"
               style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);" @close="dialogDeleteConfirm = false">
      <span style="font-size: 16px; font-weight: 500;">确认删除</span>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogDeleteConfirm = false">取消</el-button>
            <el-button type="danger" @click="handleDelete()">
              确认删除
            </el-button>
          </span>
      </template>
    </el-dialog>

  </div>

</template>

<script>
// 禁用整个文件的 ESLint 检查
/* eslint-disable */
const { postRemoteData } = require('@/api/reqWx.js');
import axios from "axios";
import {ElMessage} from "element-plus";
// 引入 socket.io-client
import io from 'socket.io-client';
import {handleEncryptData, handleDecryptData} from '@/libs/tools.js';
import {isDebug} from '@/config/config.js';

export default {
  name: "BotTask",
  // 1.根据规则发 2.根据时间发 3.多少条触发发 4.监控开始结束时间
  data() {
    return {
      minutesPickers: Array.from(Array(60).keys()),
      timeoutPickers: Array.from({length: (5000 / 500) + 1}, (_, index) => index * 500),
      timerPickers: Array.from(Array(10).keys()).map(num => num + 1),
      allRoomSettings: [],
      room_list: [],
      room_members: [{
        "key": "wxid_1",
        "value": "微信1"
      }],
      roomPeoples: [
        {
          "key": "wxid_1",
          "value": "用户1"
        }
      ],
      dialogDeleteConfirm: false,
      dialogIntervalVisible: false,
      dialogForwordVisible: false,
      message_type_list: [
        {
          "key": "11046",
          "value": "文本消息"
        },
        {
          "key": "11055",
          "value": "文件消息"
        },
      ],
      key_contents_list: [
        {
          "key": "自定义内容",
          "value": "自定义内容"
        }
      ],
      forword_to_list: [

      ],
      forwordSettings: {
        name: "转发任务配置",
        message_types: [],
        key_contents: [],
        forword_to: []
      },
      intervalSettings: {
        name: "定时任务配置",
        timer: 3,
        intervalTime: 5,
        content: "hi",
        atList: []
      },
      localCacheTasks: [],
      search: "",
      submitText: '',       // 用户输入的文本
      fileList: [],         // 存储选择的文件
      uploadedFile: null,   // 存储上传的文件
      isShowSubmitRules: false,
      roomListSelects: [],
      taskList: [
        "定时任务",
        "转发任务"
      ],
      itemSettings: {
        "taskName": "",
        "aimRoomName": "",
        "aimRoomId": "",
        "taskType": "定时任务"
      },
      deleteIndex: 0,
      dialogFormVisible: false,
      cachePageSettings: {},
      formLabelWidth: "130px",
      totalPageCount: 15,
      totalCount: 15,
      actionRow: "",
      currentAllData: [],
      showAllRoomSettings: [
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      baseWsUrl: "ws://127.0.0.1:3001",
      baseUrl: "http://127.0.0.1:3001",
      peerUrl: "https://api.8188811.xyz",
      websocket: null,
      connected: false,
      isLoin: false,
      currentLoginWx: null,
      fullLoginWxs: null,
      fullRoomList: null,
      isAuth: false,
      secret: "",
      rules: [],
      response: '',
      socket: null,
    }
  },
  async mounted() {
    // 页面加载时连接 WebSocket
    this.socket = io('http://localhost:5000');

    this.socket.on('connect', () => {
      ////console.log('WebSocket 已连接到服务器');
      // 在连接成功后执行的操作
      this.sendMessage({"data_type": "get_login_wx"})
      this.$store.commit('setWebsocket', this.socket);
    });

    // 监听服务器响应
    this.socket.on('response', (data) => {
      data = handleDecryptData(data, isDebug)
      this.response = data.data;
      ////console.log("data========")
      ////console.log(data)
      ////console.log(data["data_type"])
      if (data.hasOwnProperty("data_type")) {
        if (data["data_type"] === "get_login_wx") {
          this.check_backend(data.data)
        }
        if (data["data_type"] === "set_interval") {
          if(data.hasOwnProperty("code") && data.code === 0) {
            ElMessage.success("设置成功~")
          }
        }
        if (data["data_type"] === "action") {
          this.handleActiveLocal(data)
        }
        if (data["data_type"] === "load_room_list") {
          this.response.data.forEach((itemRoom) => {
            this.room_list.push({
              "key": itemRoom["wxid"],
              "value": itemRoom["nickname"]
            })
          })
          this.handleLoadRoomList(data.data)
        }
        if (data["data_type"] === "load_friend_list") {
          this.response.data.forEach((itemRoom) => {
            this.room_list.push({
              "key": itemRoom["wxid"],
              "value": itemRoom["nickname"]
            })
          })
          this.handleLoadRoomList(data.data)
          ////console.log(this.room_list)
        }
        if (data["data_type"] === "room_members") {
          this.handleRoomMembers(data.data)
        }
        if (data["data_type"] === "complete_interval") {
          for(let i=0;i<this.allRoomSettings.length;i++) {
            if(this.allRoomSettings[i]["taskName"] === data["taskName"]) {
              this.allRoomSettings[i]["isOpen"] = false
            }
          }
          this.showAllRoomSettings = this.allRoomSettings
        }
      }
    });

    // 监听message
    this.socket.on('message', (data) => {
      data = handleDecryptData(data, isDebug)
      ////console.log("收到消息数据", data)
      this.sendGlobalMessage(data.title, data.content, data.time)
    });

  },
  beforeUnmount() {
    // 断开 WebSocket 连接并清除定时器
    if (this.socket) {
      this.socket.disconnect();
    }
    this.localCacheTasks = [...new Set(this.localCacheTasks)];
    localStorage.setItem("localCacheTasks", JSON.stringify(this.localCacheTasks))
  },
  // 3. 在 methods 中定义函数
  methods: {
    async check_backend(resData) {
      ////console.log("后台已正常启动...", resData)
      this.fullLoginWxs = resData
      this.connected = true
      this.isAuth = resData["is_auth"]
      this.isLoin = true
      if(this.isAuth) {
        this.$store.commit('setSecret', resData["code"]);
        for (let wxid in this.fullLoginWxs) {
          if(wxid.indexOf("wxid") === -1) {
            continue
          }
          ////console.log(this.fullLoginWxs[wxid])
          ////console.log(wxid)
          ////console.log(this.fullLoginWxs[wxid]["expire_time"])
          ////console.log("this.fullLoginWxs", this.fullLoginWxs[wxid]["expire_time"])
          if (this.fullLoginWxs[wxid].hasOwnProperty("expire_time")) {
            this.$store.commit("setExpireTime", this.fullLoginWxs[wxid]["expire_time"])
          }
          if (this.fullLoginWxs.hasOwnProperty(wxid)) {
            this.currentLoginWx = this.fullLoginWxs[wxid]
            this.$store.commit("setAvatarUrl", this.currentLoginWx["avatar"])
            this.room_list = []
            await this.LoadRoomList()
            await this.LoadFriendList()
            ////console.log("this.currentLoginWx", this.currentLoginWx)

            // if(this.isLoin && this.isAuth) {
            //   setTimeout(() => {
            //     this.postSettings()
            //   }, 3000)
            // }

            this.$store.commit('setCurrentInfo', this.currentLoginWx);
            return true
          }
        }
      }
    },
    handleRulesChange(value) {
      ////console.log("rule change", value)
      if (value.includes('没有找到合适的?')) {
        // 处理值为 'xxx' 的情况
        this.isShowSubmitRules = true
      } else {
        // 处理其他选项
        ////console.log('选中了其他规则');
      }
    },
    // 选择文件时调用
    handleBeforeUpload(file) {
      // 选择文件后，保存文件对象
      this.uploadedFile = file;
      ////console.log('选择的文件:', file);

      // 这里只是为了防止自动上传，返回 false
      return false;
    },

    async LoadRoomList() {
      // let url = this.baseUrl + "/"
      let data = {
        "type": 11031,
        "is_sync": 1,
        "data": {
          "detail": 1
        },
        "data_type": "load_room_list"
      }
      ////console.log("发送请求获取群聊数据")
      this.sendMessage(data)

      // ////console.log(resData)
    },
    async LoadFriendList() {
      let data = {
        "type": 11030,
        "is_sync": 1,
        "data": {},
        "data_type": "load_friend_list"
      }
      ////console.log("发送请求获取好友数据")
      this.sendMessage(data)

      // ////console.log(resData)load_friend_list
    },
    handleLoadRoomList(resData) {
      if (resData) {
        this.allRoomSettings = []
        this.fullRoomList = resData["data"]
        ////console.log("fullRoomList: " + this.fullRoomList.length)
        let activeRoomList = []
        let afterRoomList = []
        // if(Array.isArray(this.fullRoomList)) {
        //   this.fullRoomList.forEach(item => {
        //     if (item["nickname"] !== "") {
        //
        //     }
        //   })
        // }
        this.localCacheTasks = JSON.parse(localStorage.getItem("localCacheTasks") ? localStorage.getItem("localCacheTasks") : "[]")
        this.localCacheTasks = [...new Set(this.localCacheTasks)];
        // localStorage.setItem("localCacheTasks", JSON.stringify(this.localCacheTasks))
        if (this.localCacheTasks.length > 0) {
          ////console.log(this.localCacheTasks)
          this.localCacheTasks.forEach((itemTask) => {
            ////console.log("itemTask")
            ////console.log(itemTask)
            let cacheSettings = JSON.parse(localStorage.getItem(itemTask))
            cacheSettings["order"] = this.allRoomSettings.length + 1 + ""
            activeRoomList.push(cacheSettings)
          })
        }
        this.allRoomSettings = activeRoomList.concat(afterRoomList)
        ////console.log(this.allRoomSettings)
        // 排序
        for (let i = 0; i < this.allRoomSettings.length; i++) {
          this.allRoomSettings[i]["order"] = i + 1 + ""
        }
        this.showAllRoomSettings = this.allRoomSettings
        this.sortSettingsList()
      } else {
        this.connected = false
      }
    },
    updateGlobalVariable(newData) {
      this.$store.commit('setGlobalVariable', newData);
    },
    async handleActive() {
      // let url = this.baseUrl + "/action"
      let data = {
        "type": "ACTIVE_CODE",
        "data": {
          "code": this.secret
        },
        "data_type": "action"
      }
      // let resData = await this.postAxios(url, data)
      this.sendMessage(data)

    },
    handleActiveLocal(resData) {
      ////console.log("resData", resData)
      if (resData) {
        ////console.log("resData", resData)
        this.$store.commit('setExpireTime', resData["data"]["expire_time"]);
        if(this.isAuth) {
          this.$store.commit('setHeaderExpireDialog', !resData["data"]["is_auth"]);
        } else {
          this.$store.commit('setHeaderExpireDialog', this.isAuth);
        }

        this.$store.commit('setSecret', "");

        if (resData["data"]["is_auth"]) {
          ElMessage.success("激活成功: " + resData["data"]["expire_time"])
          setTimeout(() => {
            window.location.reload()
          }, 500)
        } else {
          ElMessage.error("激活失败，请使用有效的卡密")
        }

      }
    },
    async getRoomMembers(roomId) {
      // let url = this.baseUrl + "/"
      let data = {
        "data": {
          "room_wxid": roomId
        },
        "is_sync": 1,
        "type": 11032,
        "data_type": "room_members"
      }
      // let resData = await this.postAxios(url, data)
      this.sendMessage(data)
      // ////console.log("获取群成员数据", resData)
    },
    handleRoomMembers(resData) {
      if (resData && resData.hasOwnProperty("data")) {
        let members = []
        resData["data"]["member_list"].forEach((item) => {
          members.push({
            "key": item["wxid"],
            "value": item["display_name"] === "" ? item["nickname"] : item["display_name"]
          })
        })
        this.room_members = members
        ////console.log("room_members", this.room_members)
      }
    },
    async postAxios(url, data) {
      try {
        let res = await axios.post(url, data)
        if (res.status === 200) {
          return res["data"]
        }
      } catch (e) {
        ElMessage.warning("网络异常!")
        this.connected = false
      }
    },
    sendGlobalMessage(title, content, formattedDate) {
      // let formattedDate = new Date().toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.globalMessage.unshift({
        id: this.globalMessage.length + 1,
        title: title,
        time: formattedDate,
        content: content
      })
      this.$store.state.unreadNum = this.$store.state.unreadNum + 1
      // 先检查是否超过了20条消息
      if (this.globalMessage.length >= 20) {
        // 如果超过了20条，删除最后一条消息
        this.globalMessage.splice(-1, 1);
      }
    },
    handleRefresh() {
      window.location.reload()
    },
    handleShowNextPage(itemSettings) {
      ////console.log(itemSettings)
      if(!itemSettings.aimRoomId) {
        ElMessage.error("目标微信或群聊还没有填哦~")
        return
      }
      if(!itemSettings.taskName) {
        ElMessage.error("任务昵称还没有填哦~")
        return
      }

      if(itemSettings.taskType === "转发任务") {
        this.dialogFormVisible = false
        this.dialogForwordVisible = true
        // this.getRoomMembers(itemSettings.aimRoomId)
        if(this.actionRow === "") {
          this.forwordSettings = {
            name: "转发任务配置",
            message_types: [],
            key_contents: [],
            forword_to: []
          }
          if(this.cachePageSettings) {
            this.forwordSettings = this.cachePageSettings
            this.cachePageSettings = {}
          }
        } else {
          this.forwordSettings = itemSettings["subSettings"]
        }

      }
      if(itemSettings.taskType === "定时任务") {
        this.dialogFormVisible = false
        this.dialogIntervalVisible = true
        this.getRoomMembers(itemSettings.aimRoomId)
        if(this.actionRow === "") {
          this.intervalSettings = {
            name: "定时任务配置",
            timer: 1,
            intervalTime: 300,
            content: ""
          }
          if(this.cachePageSettings) {
            this.intervalSettings = this.cachePageSettings
            this.cachePageSettings = {}
          }
        } else {
          this.intervalSettings = itemSettings["subSettings"]
        }
      }
    },
    BackLastStep() {
      ////console.log("====111")
      ////console.log(this.itemSettings)
      if(this.itemSettings.taskType === "定时任务") {
        this.dialogIntervalVisible = false
        this.dialogFormVisible = true
        this.itemSettings["subSettings"] = this.intervalSettings
        this.cachePageSettings = this.intervalSettings
      }
      if(this.itemSettings.taskType === "转发任务") {
        this.dialogForwordVisible = false
        this.dialogFormVisible = true
        this.itemSettings["subSettings"] = this.forwordSettings
        this.cachePageSettings = this.forwordSettings
      }

      ////console.log("====")
      ////console.log(this.itemSettings["subSettings"])

    },
    async SaveFormData(itemSettings) {
      ////console.log("subSettings", itemSettings)
      ////console.log("allRoomSettings", this.allRoomSettings)
      this.itemSettings["subSettings"] = itemSettings
      this.dialogFormVisible = false
      ////console.log("itemSettings", this.itemSettings)
      if(this.itemSettings.taskType === "转发任务") {
        if(!itemSettings.forword_to) {
          ElMessage.error("转发到哪还没有填哦~")
          return
        }
        if(!itemSettings.key_contents) {
          ElMessage.error("关键字内容还没有填哦~")
          return
        }
        if(!itemSettings.message_types) {
          ElMessage.error("消息内容还没有填哦~")
          return
        }
      }
      if(this.itemSettings.taskType === "定时任务") {
        if(!itemSettings.content) {
          ElMessage.error("定时发送内容还没有填哦~")
          return
        }
        if(!itemSettings.intervalTime) {
          ElMessage.error("定时间隔多少秒还没有填哦~")
          return
        }
        if(!itemSettings.timer) {
          ElMessage.error("定时多少次还没有填哦~")
          return
        }
      }

      localStorage.setItem(this.itemSettings["taskName"], JSON.stringify(this.itemSettings))
      ////console.log(this.localCacheTasks)

      this.localCacheTasks.push(this.itemSettings["taskName"]);
      this.localCacheTasks = [...new Set(this.localCacheTasks)];
      localStorage.setItem("localCacheTasks", JSON.stringify(this.localCacheTasks))
      ////console.log("this.actionRow", this.actionRow)
      if(this.actionRow === "") {
        this.itemSettings["order"] = this.allRoomSettings.length >= 1 ? parseInt(this.allRoomSettings[0].order) + 1 + "" : "1"
        this.allRoomSettings.unshift(this.itemSettings)
        this.sortSettingsList()
        this.showAllRoomSettings.sort((a, b) => {
          if (a.aimRoomId === this.itemSettings.aimRoomId) return -1; // 当前项是目标项，排前面
          if (b.aimRoomId === this.itemSettings.aimRoomId) return 1;  // 目标项在 b 中，排后面
          return 0; // 保持原顺序
        });
      } else {
        this.allRoomSettings[this.actionRow] = this.itemSettings
      }
      ////console.log(this.allRoomSettings)
      this.showAllRoomSettings = this.allRoomSettings
      await this.postSettings(this.itemSettings)

      if(this.itemSettings.taskType === "转发任务") {
        this.dialogForwordVisible = false
      }
      if(this.itemSettings.taskType === "定时任务") {
        this.dialogIntervalVisible = false
      }
    },
    SaveToItem(intervalSettings) {
      this.itemSettings["subSettings"] = intervalSettings
      this.dialogIntervalVisible = false
      ////console.log(this.itemSettings)
    },
    sortSettingsList() {
      this.showAllRoomSettings.sort((a, b) => {
        if (a.isOpen === b.isOpen) {
          return 0; // 保持原有顺序
        }
        return a.isOpen ? -1 : 1; // isOpen 为 true 的排在前面
      });
    },
    searchChange(newValue) {
      ////console.log(newValue)
      this.showAllRoomSettings = this.allRoomSettings.filter(data => !newValue || data.aimRoomName.toLowerCase().includes(newValue.toLowerCase()))
    },
    async postSettings(row) {
      // 将配置信息发送过去
      let preData = {}
      preData["active_groups"] = []
      preData["data_type"] = "set_interval"
      preData["active_groups"].push(row["aimRoomId"])
      preData["current_wxid"] = this.currentLoginWx["wx_id"]
      preData[row["aimRoomId"]] = row
      ////console.log("发送数据", preData)

      // let url = this.baseUrl + "/settings"
      // let res = await axios.post(url, preData)
      // if(res.status === 200) {
      //   ////console.log("返回数据:", res.data)
      // }
      ////console.log("发送了", preData)
      this.sendMessage(preData)
    },
    sendMessage(data) {
      if (this.socket) {
        this.socket.emit('message', handleEncryptData(data, isDebug));
      } else {
        console.error('WebSocket not connected!');
      }
    },
    handlePageChange(page) {
      if (!this.isAllData) {
        this.currentData = this.currentAllData.slice((page - 1) * this.pageSize, (page) * this.pageSize)
      } else {
        this.pageCount = page
        this.getTaskOrder()
      }
    },
    handleTaskTypeChange(value) {
      ////console.log('选中任务类型:', value);
      this.itemSettings["taskName"] = value + "_" + new Date().getTime()
      // 在这里添加点击事件的业务逻辑
    },
    handleRoomChange(newRoomId) {
      // 根据新的aimRoomId（选中的群聊ID）找到对应的aimRoomName
      const selectedRoom = this.room_list.find(room => room.key === newRoomId);
      if (selectedRoom) {
        this.itemSettings.aimRoomName = selectedRoom.value;
      }
    },
    handleAdd(){
      this.dialogFormVisible = true
      this.actionRow = ""
      this.itemSettings = {
        "taskName": "",
        "aimRoomName": "",
        "aimRoomId": "",
        "taskType": "定时任务"
      }
      this.itemSettings["taskName"] = this.itemSettings["taskType"] + "_" + new Date().getTime()
    },
    showHandleDelete(index, row) {
      ////console.log("index", index)
      ////console.log("row", row)
      this.itemSettings = row
      this.deleteIndex = index
      this.dialogDeleteConfirm = true
    },
    handleDelete() {
      ////console.log(" handleDelete this.itemSettings")
      ////console.log(this.itemSettings)
      this.allRoomSettings.splice(this.deleteIndex, 1);
      this.showAllRoomSettings = this.allRoomSettings
      this.dialogDeleteConfirm = false
      this.localCacheTasks = this.localCacheTasks.filter(item => item !== this.itemSettings["taskName"]);
      localStorage.setItem("localCacheTasks", JSON.stringify(this.localCacheTasks))
    },
    handleEdit(index, row) {
      this.actionRow = index
      ////console.log(index, row)
      this.dialogFormVisible = true
      ////console.log("row", row)
      ////console.log("index", index)
      this.itemSettings = row
      this.intervalSettings = this.itemSettings["subSettings"]
      // 获取群成员
      // this.getRoomMembers(row.roomId)
    },
    changePage(currentPage) {
      // 在这里处理分页切换逻辑，currentPage 即为当前页码
      ////console.log('当前页码:', currentPage);
      this.currentPage = currentPage
    },
    async handleSwitchChange(row, value) {
      ////console.log(row)
      localStorage.setItem(row["taskName"], JSON.stringify(row))
      this.localCacheTasks.push(row["taskName"]);
      this.localCacheTasks = [...new Set(this.localCacheTasks)];
      localStorage.setItem("localCacheTasks", JSON.stringify(this.localCacheTasks))
      await this.postSettings(row)

    },
    updateTotal() {
      this.total = this.isAllData.length;
    },
    calculateRemainingSeconds(targetMinute) {
      // 获取当前时间
      const now = new Date();
      let setTime = new Date();

      // 获取当前小时和分钟
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      setTime.setHours(currentHour, targetMinute, 0, 0)
      if (currentMinute >= targetMinute) {
        setTime = new Date(setTime.getTime() + 3600 * 1000)
      } else {
        setTime.setHours(currentHour, targetMinute, 0, 0)
      }
      return setTime.getTime() - now.getTime()
    }
  },
  // 4. 在 computed 中定义计算属性
  computed: {
    // 使用全局变量
    globalVariable() {
      return this.$store.state.globalVariable;
    },
    currentInfo() {
      return this.$store.state.currentInfo;
    },
    filterTableData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.showAllRoomSettings.slice(startIndex, endIndex);
    },
    pageCount() {
      return parseInt(this.allRoomSettings.length / this.pageSize) + 1
    },
    globalMessage() {
      return this.$store.state.globalMessage;
    },
    unreadNum() {
      return this.$store.state.unreadNum;
    },
    selfRules() {
      return this.$store.state.selfRules;
    },
    currentPageData() {
      // 用于渲染当前页的数据
      return this.filterTableData;
    },
  },
}
</script>


<style lang="scss" scoped>
.button-container {
  display: flex;            /* 使用 flex 布局 */
  justify-content: flex-start;  /* 元素靠左排列 */
  gap: 10px;               /* 按钮之间的间距，可以根据需要调整 */
  margin-top: 10px;
}
.center-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60%; /* 使容器占据整个视口的高度 */
}

.instruction-text {
  color: white;
  font-size: 20px;
  margin: 10px 0; /* 设置上下间隙，根据需要调整数值 */
}

/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}

/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
  background-color: transparent !important;
  border: 0; //去除表格
}

::v-deep .el-pagination {
  background-color: transparent !important;
  border: 0; //去除表格
}

/*去除底边框*/
::v-deep.el-table td.el-table__cell {
  border: 0;
}

::v-deep.el-table th.el-table__cell.is-leaf {
  border: 0;
}

/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
  display: none;
  height: 0;
}

::v-deep .el-table__inner-wrapper::before {
  height: 0;
}

.dynamic-width-input {
  width: 300px; /* 设置默认较短的宽度 */
  min-width: 100px; /* 设置最小宽度 */
  max-width: 500px; /* 设置最大宽度 */
}


// 分页样式改造
::v-deep .el-pagination.is-background .btn-prev {
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination.is-background .btn-next {
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li {
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #cc66ff;
}

::v-deep .el-pagination__editor.el-input .el-input__inner {
  background: transparent;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination__total, ::v-deep .el-pagination__jump {
  color: #fff;
}

.dialog-content {
  background: -webkit-linear-gradient(left, rgb(145, 217, 246) 0%, #db6ff3 100%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0;
}

.fade-enter-to, .fade-leave {
  opacity: 1;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.icon-container-left {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
}

.custom-btn {
  width: 130px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 10px;
  //margin: 0 10px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5), 7px 7px 20px 0px rgba(0, 0, 0, .1),
  4px 4px 5px 0px rgba(0, 0, 0, .1);
  outline: none;

}

.btn-9 {
  border: none;
  transition: all 0.3s ease;
  overflow: hidden;

  &:after {
    position: absolute;
    content: " ";
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1fd1f9;
    background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);
    transition: all 0.3s ease;
  }

  &:hover {
    background: transparent;
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, .5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
    color: #fff;
  }

  &:hover:after {
    -webkit-transform: scale(2) rotate(180deg);
    transform: scale(2) rotate(180deg);
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, .5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
  }
}

.btn-12 {
  position: relative;
  right: 20px;
  bottom: 20px;
  border: none;
  box-shadow: none;
  width: 130px;
  height: 40px;
  line-height: 42px;
  -webkit-perspective: 230px;
  perspective: 230px;

  & span {
    background: rgb(0, 172, 238);
    background: linear-gradient(0deg, rgba(0, 172, 238, 1) 0%, rgba(2, 126, 251, 1) 100%);
    display: block;
    position: absolute;
    width: 130px;
    height: 40px;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
    7px 7px 20px 0px rgba(0, 0, 0, .1),
    4px 4px 5px 0px rgba(0, 0, 0, .1);
    border-radius: 5px;
    margin: 0;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all .3s;
    transition: all .3s;
  }

  & span:nth-child(1) {
    box-shadow: -7px -7px 20px 0px #fff9,
    -4px -4px 5px 0px #fff9,
    7px 7px 20px 0px #0002,
    4px 4px 5px 0px #0001;
    -webkit-transform: rotateX(90deg);
    -moz-transform: rotateX(90deg);
    transform: rotateX(90deg);
    -webkit-transform-origin: 50% 50% -20px;
    -moz-transform-origin: 50% 50% -20px;
    transform-origin: 50% 50% -20px;
  }

  & span:nth-child(2) {
    -webkit-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: 50% 50% -20px;
    -moz-transform-origin: 50% 50% -20px;
    transform-origin: 50% 50% -20px;
  }

  &:hover span:nth-child(1) {
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
    7px 7px 20px 0px rgba(0, 0, 0, .1),
    4px 4px 5px 0px rgba(0, 0, 0, .1);
    -webkit-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }

  &:hover span:nth-child(2) {
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
    7px 7px 20px 0px rgba(0, 0, 0, .1),
    4px 4px 5px 0px rgba(0, 0, 0, .1);
    color: transparent;
    -webkit-transform: rotateX(-90deg);
    -moz-transform: rotateX(-90deg);
    transform: rotateX(-90deg);
  }
}

</style>

